import { BoxCutterIcon } from './BoxCutterIcon';

/**
 * author: Simran
 * id A4C51C21-DEB0-4247-AEA3-B5F454641BDC
 * name box-cutter
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/box-cutter.svg
 * tags
 * - Hardware / Tools 
 */
export const StanleyKnifeIcon = BoxCutterIcon;
export default StanleyKnifeIcon